import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
import { getPerformance } from 'firebase/performance'
import { trace } from 'firebase/performance'

export const firebaseConfig = {
  apiKey: "AIzaSyDbLm8KGyAZ1ITtybE6k6j8ek4XRqUbj1E",
  authDomain: "jawwal-dynamic-v4.firebaseapp.com",
  databaseURL: "https://jawwal-dynamic-v4.firebaseio.com",
  projectId: "jawwal-dynamic-v4",
  storageBucket: "jawwal-dynamic-v4.appspot.com",
  messagingSenderId: "672621951606",
  appId: "1:672621951606:web:57272127caf5be4a873d57",
  measurementId: "G-RT3F4EZLH8"
}
const firebaseApp = initializeApp(firebaseConfig)
const messaging = getMessaging(firebaseApp)
const perf = getPerformance(firebaseApp)
export const createTrace = (traceName) => {
  return trace(perf, traceName)
}

export const requestForToken = async () => {
  if ('Notification' in window) {
    let permission = Notification.permission
    if (permission === 'default') {
      permission = await Notification.requestPermission()
    }
    if (permission !== 'granted') {
      return ''
    }

    return getToken(messaging, {
      vapidKey:
        'BEY-kj67ZTbhMIDdC9jTDw0gaQfwniKWMyBysCGdA5k0NEcGJG20fzQ_0NCvMmGm28y4YJSWsrZ9Rw1zC3GVnE4',
    })
      .then((currentToken) => {
        if (currentToken) {
          return currentToken
        } else {
          return ''
        }
      })
      .catch((err) => {
        return ''
      })
  }
  return ''
}
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload)
    })
  })

export {perf}